import Text from '../../Text';
import {
  DisclaimerText,
  PreviewHeadline,
  TileContent,
} from '../StyledComponents';
import { htmlSanitizer } from '../../../lib/helpers';

const TileTextsContainer = ({
  headline,
  supportingContent,
  disclaimerText,
}) => {
  return (
    <div className="tile_texts_container" style={{ padding: '0px' }}>
      <PreviewHeadline
        aria-label="Tile headline"
        dangerouslySetInnerHTML={htmlSanitizer(headline)}
      />
      <TileContent>
        <p dangerouslySetInnerHTML={htmlSanitizer(supportingContent)} />
        {disclaimerText && (
          <DisclaimerText>
            <Text
              variant="small2"
              dangerouslySetInnerHTML={htmlSanitizer(disclaimerText)}
            />
          </DisclaimerText>
        )}
      </TileContent>
    </div>
  );
};

export default TileTextsContainer;
